import { IUserProfile, Tier } from "@centraldispatch/singlespa-utilities";

export interface IGtm {
  startGtm(user: IUserProfile);
}

export class Gtm implements IGtm {
  async startGtm(user: IUserProfile) {
    const w = window;
    w["dataLayer"].push({
      common: {
        user: {
          bridgeUser: null,
          applicationUser: user.username,
          userType: user.tierGroup.toString(),
          isInternalUser: false,
        },
        context: {
          dealershipName:
            user.tierGroup === Tier.DEALER ? user.companyName : null,
        },
      },
    });

    w["dataLayer"].push({
      companyName: user.companyName,
    });

    w["dataLayer"].push({
      userType: user.tierGroup.toString(),
    });

    w["dataLayer"].push({
      event: "user_type_dimension",
      user_type: user.tierGroup.toString(),
    });
    w["dataLayer"].push({
      event: "dataLayerReady",
      dataLayerReady: true,
    });
  }
}
